 
 
 
 
 
 
define(function(require) {
    'use strict';
    var mapboxSetStyleMethodModifier = require('./setStyleMethodModifier/mapboxSetStyleMethodModifier');
    var mainConfig = require('mainConfig');

    var mapboxgl;
    var isRtlPluginSet = false;

    function tryToGetMapbox() {
        var mapbox, rtlPlugin, objectURL;
        try {
            mapbox = require('mapbox-gl-js');

            //This flag is necessary, because setRTLTextPlugin throws error
            //setRTLTextPlugin cannot be called multiple times
            if (!isRtlPluginSet) {
                rtlPlugin = require('raw-loader!mapbox-gl-rtl-text');
                objectURL = window.URL.createObjectURL(new window.Blob([rtlPlugin], {type: 'text/javascript'}));
                //setRTLTextPlugin expects objectURL
                mapbox.setRTLTextPlugin(objectURL);
                isRtlPluginSet = true;
            }
            mapboxSetStyleMethodModifier.modifySetStyle(mapbox);
            return mapbox;
        } catch (e) {
            /**
             * hack to have optional dependency of mapboxgl
             * If you have some problems with mapbox support uncomment line below.
             * We are swallowing some errors here.
             */
            //console.error(e, e.stack);
            return null;
        }
    }

    mapboxgl = tryToGetMapbox();

    return {
        setMapbox: function(mapboxReference) {
            if (mapboxReference && mapboxReference.version !== mainConfig['mapboxgl.version']) {
                console.warn('TomTom Maps SDK for Web expects mapboxgl "' + mainConfig['mapboxgl.version'] +
                '" version.');
            }
            mapboxgl = mapboxReference;
            mapboxSetStyleMethodModifier.modifySetStyle(mapboxgl);
        },
        tryToSetMapbox: function() {
            if (!this.isMapboxSet()) {
                mapboxgl = tryToGetMapbox();
            }
            return this.isMapboxSet();
        },
        getMapbox: function() {
            if (!this.isMapboxSet()) {
                throw new Error('You should provide Mapbox GL JS reference first.');
            }
            return mapboxgl;
        },
        isMapboxSet: function() {
            return Boolean(mapboxgl);
        },
        isMapboxSupported: function() {
            return this.tryToSetMapbox() && mapboxgl.supported();
        }
    };
});



// WEBPACK FOOTER //
// ./display/layers/vector/mapboxProvider.js